<template>
  <div class="couponPackage">
    <el-tabs v-model="activeName" @tab-click="handleChangeTab">
      <el-tab-pane :label="'未使用('+notUsedData.length+')'" name="notUsed">
        <div class="couponList" v-if="flag">
          <div class="clearfix sub-main">
            <div class="couponItem active" v-for="(item, index) of notUsedData" :key="index">
              <div class="couponItemTop">
                <img src="../../../assets/images/indexLogo.png" alt="">
                <span><i>￥</i>{{item.reduceMoney}}<span class="mar-left-10" style="display: inline-block;font-size:16px;">{{item.couponType===2?'折扣券':'满减券'}}</span></span>
                <span>使用条件：{{item.content}}</span>
                <span>有效期至：{{item.endTime}}</span>
                <div class="couponType" v-if="item.couponId!=0">平台卷</div>
                <div class="couponType" v-if="item.shopCouponId!=0">店铺券</div>
              </div>
              <div class="couponItemBot" @click="useCoupon(item.activityId,item.shopCouponId)">
                立即使用
              </div>
            </div>
          </div>
<!--          <el-pagination-->
<!--            background-->
<!--            layout="prev, pager, next, jumper"-->
<!--            :total="1000">-->
<!--          </el-pagination>-->
        </div>
        <div class="nothing sub-main" v-else>
          <img src="../../../../static/image/noorder@2x.png" alt="">
          <p class="fs20 font-color-999">没有该类型的优惠券～</p>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="'已使用('+usedData.length+')'" name="used">
        <div class="couponList" v-if="flag1">
          <div class="clearfix sub-main">
            <div class="couponItem" v-for="(item, index) of usedData" :key="index">
              <div class="couponItemTop">
                <img src="../../../assets/images/indexLogo.png" alt="">
                <span><i>￥</i>{{item.reduceMoney}}</span>
                <span>使用条件：{{item.content}}</span>
                <span>有效期至：{{item.endTime}}</span>
                <div class="couponType" v-if="item.couponId!=0">平台卷</div>
                <div class="couponType" v-if="item.shopCouponId!=0">店铺券</div>
              </div>
              <div class="couponItemBot">
                已使用
              </div>
            </div>
          </div>
          <!--          <el-pagination-->
          <!--            background-->
          <!--            layout="prev, pager, next, jumper"-->
          <!--            :total="1000">-->
          <!--          </el-pagination>-->
        </div>
        <div class="nothing" v-else>
          <img src="../../../../static/image/noorder@2x.png" alt="">
          <p class="fs20 font-color-999">没有该类型的优惠券～</p>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="'已失效('+invalid.length+')'" name="invalid">
        <div class="couponList" v-if="flag2">
          <div class="clearfix sub-main">
            <div class="couponItem" v-for="(item, index) of invalid" :key="index">
              <div class="couponItemTop">
                <img src="../../../assets/images/indexLogo.png" alt="">
                <span><i>￥</i>{{item.reduceMoney}}</span>
                <span>使用条件：{{item.content}}</span>
                <span>有效期：{{item.startTime}}-{{item.endTime}}</span>
                <div class="couponType" v-if="item.couponId!=0">平台卷</div>
                <div class="couponType" v-if="item.shopCouponId!=0">商家券</div>
              </div>
              <div class="couponItemBot">
                已失效
              </div>
            </div>
          </div>
          <!--          <el-pagination-->
          <!--            background-->
          <!--            layout="prev, pager, next, jumper"-->
          <!--            :total="1000">-->
          <!--          </el-pagination>-->
        </div>
        <div class="nothing sub-main" v-else>
          <img src="../../../../static/image/noorder@2x.png" alt="">
          <p class="fs20 font-color-999">没有该类型的优惠券～</p>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import api from '@/api'
import { listSearchMixin } from '@/config/mixin'
export default {
  name: 'couponPackage',
  mixins: [listSearchMixin],
  data () {
    return {
      activeName: 'notUsed',
      notUsedData: [],
      usedData: [],
      invalid: [],
      flag: true,
      flag1: true,
      flag2: true
    }
  },
  mounted () {
    this.getCouponList(0)
    this.getCouponList(1)
    this.getCouponList(2)
   },
  methods: {
    // 获取优惠券列表
    getCouponList (state) {
      const rLoading = this.openLoading()
      let self = this
      let params = {
        url: api.getCouponList,
        method: 'GET',
        payload: {
          state: state
        }
      }
      self.sendReq(params, (res) => {
        if (res.code === '200') {
          if (state === 0) {
            self.notUsedData = res.data
            self.flag = res.data.length
          } else if (state === 1) {
            self.usedData = res.data
            self.flag1 = res.data.length
          } else if (state === 2) {
            self.invalid = res.data
            self.flag2 = res.data.length
          }
          rLoading.close()
        } else {
          self.$message.warning(res.message)
        }
      })
    },
    handleChangeTab (tab, event) {
      // console.log(tab, event)
    },
    // 使用优惠券
    useCoupon (id, shopCouponId) {
      this.$router.push({
        name: 'couponProList',
        query: {
          activityId: id,
          shopCouponId
        }
      })
    }
    // useCoupon () {
    //   this.$router.push('/')
    // }
  }
}
</script>

<style lang="scss" scoped>
.couponPackage {
  // border: 1px solid #E5E5E5;
  min-height: 500px;
  >>> .el-tabs__nav-scroll {
    padding-left: 30px;
    .el-tabs__nav {
      height: 60px;
      line-height: 60px;
    }
  }
  >>> .el-tabs__content {
    padding:0 30px;
  }
  .couponList {
    margin-bottom: 30px;
    padding: 20px;
    .couponItem {
      width: 245px;
      border: 1px solid #EEEEEE;
      border-radius: 18px;
      overflow: hidden;
      margin:0 100px 50px 0;
      float: left;
      &:nth-child(3n) {
        margin-right: 0;
      }
      .couponItemTop {
        background: #d7d7d7;
        color: #ffffff;
        padding: 20px;
        box-sizing: border-box;
        position: relative;
        img {
          opacity: 0.2;
          position: absolute;
          top: 40%;
        }
        .couponType {
          position: absolute;
          top: 1px;
          right: -33px;
          width: 100px;
          transform: rotate(45deg);
          background: #FFFFFF;
          color: #999999;
          text-align: center;
          height: 40px;
          line-height: 50px;
        }
        span {
          font-size: 12px;
          display: block;
          margin-bottom: 18px;
          cursor: pointer;
          i {
            margin-right: 5px;
            font-style: normal;
            font-size: 16px;
          }
        }
        span:nth-child(2) {
          font-size: 28px;
        }
        span:nth-child(4) {
          margin-bottom: 0;
        }
      }
      .couponItemBot {
        height: 40px;
        line-height: 40px;
        color: #999999;
        position: relative;
        text-align: center;
        background: #FFFFFF;
        cursor: pointer;
      }
    }
    .active {
      .couponItemTop {
        background: #fd5b5b;
        color: #ffffff;
        .couponType {
          background: #FFFFFF;
          color: #fd5b5b;
        }
      }
      .couponItemBot {
        background: #f3f3f3;
        color: #333333;
      }
    }
  }
}
.sub-main{
  min-height: 400px;
}
.nothing{
    width: 100%;
    text-align: center;
    min-height: 400px;
    p{
        margin-bottom: 20px;
    }
    .el-button{
        background-color: #FF7800;
        color: #FFFFFF;
        font-weight: normal;
        border-radius: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/userCenter/couponPackage/couponPackage.vue